module.exports = __webpack_public_path__ + "img/adcc_affiliate.a131adc1.webp";